const $inject = ['$rootScope', '$scope', '$routeParams', 'dataService'];

const lbaSwitchCtrl = function ($rootScope, $scope, $routeParams, dataService) {
    const vm = this;
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    vm.disabled = false;

    function checkAtLeastOneTrue() {
        setTimeout(() => {
            let atLeastOneTrue = vm.settings.disableIfAllFalse.find((field) => {
                const lookUp = dataService.spiltDataAt(field, $routeParams);
                let data = _.get(dataService.data.activeItem, lookUp);
                return data;
            });

            if (atLeastOneTrue) {
                vm.disabled = false;
            } else {
                vm.data = false;
                vm.disabled = true;
            }

            $scope.$apply();
        });
    }

    setTimeout(() => {
        if (vm.settings.prerequisiteFor) {
            vm.settings.prerequisiteFor.forEach((item) => {
                $rootScope.$broadcast('disableSwitch', { lookUp: item, value: vm.data });
            });
        }

        if (vm.settings.disableIfAllFalse) {
            checkAtLeastOneTrue();
        }
    });

    if (vm.settings.notNullable && vm.data == null) {
        _.set(dataService.data.activeItem, dataLookUp, false);
    }

    $scope.$watchCollection('vm.data', function (newData, oldData) {
        if (newData !== oldData) {
            if (vm.settings.prerequisiteFor) {
                vm.settings.prerequisiteFor.forEach((item) => {
                    $rootScope.$broadcast('disableSwitch', { lookUp: item, value: newData });
                });
            }

            _.set(dataService.data.activeItem, dataLookUp, newData);
        }
    });

    $rootScope.$on('disableSwitch', (event, data) => {
        if (vm.settings.disableIfAllFalse) {
            checkAtLeastOneTrue();
            return;
        }

        if (vm.settings.dataAt === data.lookUp) {
            vm.disabled = !data.value;
            if (!data.value) {
                _.set(dataService.data.activeItem, dataLookUp, data.value);
                vm.data = _.get(dataService.data.activeItem, dataLookUp);
            }
        }
    });
};

lbaSwitchCtrl.$inject = $inject;

export default lbaSwitchCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaSwitch/lbaSwitchCtrl.js